import React from 'react';
import Button from '@mui/material/Button';
import Delete from '@mui/icons-material/Delete';

interface DeleteIconButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({ onClick, disabled = false }) => (
  <Button variant="contained" color="warning" onClick={onClick} disabled={disabled}>
    <Delete />
  </Button>
);

export default DeleteIconButton;
